import { defineMessages } from "react-intl";
const messages = defineMessages({
    scrollTo: {
        id: "aiDiscoverability.inPageSectionNav.scrollTo",
        defaultMessage: "Scroll to",
    },
});
export default messages;
